import { useMemo } from 'react';

import posthog from 'posthog-js';

import type { VideoRoomAnalyticsPort } from '@zingizi/video-room';

import { usePosthogCapture } from '../../hooks/usePosthogCapture';

import type { IUser } from '../../store/types';

interface UseZingiziAnalyticsAdapterArgs {
  userData?: IUser | null;
}

export function useZingiziAnalyticsAdapter({ userData }: UseZingiziAnalyticsAdapterArgs): VideoRoomAnalyticsPort {
  const captureEvent = usePosthogCapture();

  // Порт попадает в deps коллбэков сессии: новый объект на каждый рендер
  // пересоздавал бы их и перезапускал зависящие эффекты.
  return useMemo<VideoRoomAnalyticsPort>(
    () => ({
      capture(eventName, properties) {
        if (userData?.id) {
          captureEvent(eventName, properties ?? {});
          return;
        }

        posthog.capture(eventName, properties ?? {});
      },
    }),
    [captureEvent, userData?.id],
  );
}
